// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"07f9a717","785":"07f9a717"}[chunkId] + ".chunk.css";
};